import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var EnvironmentRobotsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(EnvironmentRobotsModalComponent, _super);
    function EnvironmentRobotsModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EnvironmentRobotsModalComponent;
}(UiModalComponent));
export { EnvironmentRobotsModalComponent };
